import { useNavigate } from "react-router-dom";

export const useTraining = () => {
  const navigate = useNavigate();
  return { navigate };
};
